import { VIEWPORT_EDGE_INSET, TRIGGER_GAP, MIN_COMFORTABLE_SPACE } from './tooltipPosition.constants'

/**
 * Chooses whether a trigger-anchored popover opens above or below: below when
 * there's room, else above. `isLastRow` prefers above near the list bottom.
 */
export function getTooltipPositionClass(
    isLastRow: boolean,
    element: HTMLElement | null,
    windowHeight: number,
    preferredHeight: number = MIN_COMFORTABLE_SPACE,
): 'bottom' | 'top' {
    if (!element) return 'bottom'
    const r = element.getBoundingClientRect()
    const spaceBelow = windowHeight - r.bottom - VIEWPORT_EDGE_INSET
    const spaceAbove = r.top - VIEWPORT_EDGE_INSET
    const need = Math.min(preferredHeight, MIN_COMFORTABLE_SPACE)

    if (isLastRow && spaceBelow < need + TRIGGER_GAP) return 'top'
    // Triggers in the upper viewport should open downward.
    const triggerMidY = r.top + r.height / 2
    if (triggerMidY < windowHeight * 0.4 && spaceBelow >= need + TRIGGER_GAP) {
        return 'bottom'
    }
    if (spaceBelow >= need + TRIGGER_GAP) return 'bottom'
    if (spaceAbove >= need + TRIGGER_GAP) return 'top'
    return spaceAbove > spaceBelow ? 'top' : 'bottom'
}

/** Max height (px) the popover may use in the chosen direction. */
export function getPopoverMaxHeightInDirection(
    element: HTMLElement,
    openUp: boolean,
    windowHeight: number,
    globalCap: number,
): number {
    const r = element.getBoundingClientRect()
    const available = openUp
        ? r.top - VIEWPORT_EDGE_INSET - TRIGGER_GAP
        : windowHeight - r.bottom - VIEWPORT_EDGE_INSET - TRIGGER_GAP
    // Never exceed space in the chosen direction (a floor would clip past the viewport top).
    return Math.min(globalCap, Math.max(0, Math.floor(available)))
}
